import { REHYDRATE } from "redux-persist";
const initialState = {
  loggedIn: false,
  userData: {},
};

export function authentication(state = initialState, action: any) {
  switch (action.type) {
    case REHYDRATE:
      // Authentication is not persisted, so always return initial state on rehydrate
      // We rely on cookies for authentication persistence
      if (action.payload && action.payload.authentication) {
        return {
          ...state,
          loggedIn: action.payload.authentication.loggedIn || false,
          userData: action.payload.authentication.userData || {},
        };
      }
      return state;
    case "SET_USER": {
      return {
        loggedIn: true,
        userData: action.payload,
      };
    }
    case "LOG_OUT": {
      return initialState;
    }
    default: {
      return state;
    }
  }
}
